import React, { useContext, useState } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURL, buildURLForCategory } from "../../utils/buildURL";
import "./style.scss";

import { useStaticQuery, graphql } from "gatsby";
import Link from "../../utils/Link";

export const query = graphql`
  query {
    api {
      aboutUsPrizes {
        id
        created_at
        updated_at
        slug
        title {
          text_sq
          text_en
        }
        date
        body {
          text_sq
          text_en
        }
        image {
          url
        }
      }
    }
  }
`;

export default function Awards({ children }) {
  const { userLanguage } = useContext(LanguageContext);
  const apiData = useStaticQuery(query);
  const plainAwards = apiData.api.aboutUsPrizes;

  const awards = plainAwards.map((a) => {
    a.year = new Date(a.date).getFullYear();
    return a;
  });

  const years = awards.map((a) => a.year).sort((a, b) => b - a);
  const [year, setYear] = useState(years[0]);

  const awardsInYear = awards.filter((a) => a.year === year);

  return (
    <>
      <div className="years">
        <div className="container">
          {years.map((y) => (
            <span
              className={y === year ? "active" : ""}
              onClick={() => setYear(y)}
            >
              {y}
            </span>
          ))}
        </div>

        {awardsInYear.map((a) => (
          <Link to={`/cmime/${a.slug}`}>
            <h3
              className="content-header__subtitle"
              style={{ fontSize: "32px ​!importan" }}
            >
              {text(a.title, userLanguage)}
            </h3>
          </Link>
        ))}
      </div>
    </>
  );
}
